import { render, staticRenderFns } from "./ResetPasswordConfirmation.vue?vue&type=template&id=e5745e2e&"
import script from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports